import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage } from "./message";

import userService from "../services/user.service";

export const getTypeSearchVideos = createAsyncThunk(
  "typeSearchVideos/getTypeSearchVideos",
  async (queryParams, thunkAPI) => {
    try {
      const response = await userService.getTypeSearchVideos(queryParams);
      thunkAPI.dispatch(setMessage(response.data));
      return response.data.details;
    } catch (error) {
      thunkAPI.dispatch(setMessage(error.response));
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

const initialState = { videos: [], isFetching: false, isFetched: false, page: 2 };

const typeSearchVideosSlice = createSlice({
  name: "typeSearchVideos",
  initialState,
  reducers:{
    setTypeVideos: (state, action) => {
      state.videos = action.payload;
    }
  },
  extraReducers: {
    [getTypeSearchVideos.fulfilled]: (state, action) => {
      state.isFetching = false;
      state.isFetched = true;
      state.videos = [...state.videos, ...action.payload];
      state.page = state.page + 1;
    },
    [getTypeSearchVideos.rejected]: (state, action) => {
      state.isFetching = false;
      state.isFetched = false;
    }
  },
});

const { reducer, actions } = typeSearchVideosSlice;
export const { setTypeVideos } = actions
export default reducer;
